import { useEffect, useRef, useState } from "react";
import homePageAPI from "../../api/homePageApi";
import homePagePayload from "../../config.js/homePayload";


// const testimonials = [
//   {
//     id: 1,
//     name: "Ravi Shankar",
//     role: "CEO, Apple",
//     text: "As a satisfied customer of the SAAS company offering high-quality website templates with quick turnaround times, I have nothing but praise for their exceptional services!",


//   },
//   {
//     id: 2,
//     name: "Ravi Shankar",
//     role: "CEO, Apple",
//     text: "As a satisfied customer of the SAAS company offering high-quality website templates with quick turnaround times, I have nothing but praise for their exceptional services!",
//   },
//   {
//     id: 3,
//     name: "Sara Mitchell",
//     role: "CMO, Google",
//     text: "The team delivered beyond expectations. Clean designs, fast delivery, and exceptional support throughout the entire project lifecycle.",
//   },
//   {
//     id: 4,
//     name: "James Carter",
//     role: "Founder, Meta",
//     text: "Truly world-class service. Our conversion rate doubled within three months of launching the new website template. Highly recommended!",
//   },
// ];

const styles = `
 

  :root {
    --color-white: #ffffff;
    --color-black: #000000;
    --color-dark: #121212;
    --color-gray: #4a4a4a;
    --color-light-gray: #b9b6b6;
    --color-text-muted: #777777;
    --color-primary: #f73400;
    --color-primary-dark: #c52900;
    --color-secondary: #36e3bf;
    --color-accent: #4dcea8;
    --color-orange: #ff4d00;
    --color-orange-light: #ff8c00;
    --ax-brand-orange: #f73400;
    --ax-dark-gradient: linear-gradient(90deg, #4a4a4a 0%, #000 100%);
    --gradient-primary: linear-gradient(45deg, #f73400, #36e3bf);
    --gradient-dark: linear-gradient(90deg, #4a4a4a 0%, #000 100%);
    --gradient-orange: linear-gradient(45deg, #ff4d00, #ff8c00);
    --gradient-banner: linear-gradient(36deg, #282629, #1c2227, #f73400 127%);
    --gradient-cta: linear-gradient(to right, #c52900, #000);
    --font-gilroy: 'gilroy', sans-serif;
    --font-gilroy-medium: 'gilroy-medium', sans-serif;
    --font-kalam: 'kalam', cursive;
    --font-arcade: 'arcadeclassic', sans-serif;
    --font-droid: 'disposabledroid-bb', sans-serif;
    --font-default: 'Arial', sans-serif;
    --fs-xl: 128px;
    --fs-lg: 111px;
    --fs-md: 64px;
    --fs-sm: 48px;
    --fs-xs: 28px;
    --radius-sm: 10px;
    --radius-md: 31px;
    --radius-lg: 40px;
    --radius-xl: 55px;
    --padding-sm: 10px;
    --padding-md: 20px;
    --padding-lg: 40px;
    --transition-fast: 0.3s;
    --transition-smooth: 0.5s cubic-bezier(0.19, 1, 0.22, 1);
    --orange: #ff4500;
    --teal: #40e0d0;
    --sphere-grad: radial-gradient(circle at 30% 30%, #dcd8d8 0%, #2a2a2a 100%);
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

 
`;

function Avatar({ name }) {
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
  return (
    <div className="ax-testi-avatar">
      <span className="ax-testi-avatar-initials">{initials}</span>
    </div>
  );
}

function TestimonialCard({ testimonial }) {
  return (
    <div className="ax-testi-card">
      
      {/* TOP WHITE STRIP */}
      <div className="ax-testi-card-top">
        <div className="ax-testi-avatar">
          {/* <span className="ax-testi-avatar-initials">
            {testimonial.name
              .split(" ")
              .map(n => n[0])
              .join("")
              .slice(0, 2)}
          </span> */}

          <img src={testimonial.image} alt="img"  className="ax-testi-avatar-initials"   loading="lazy"/>
        </div>

        <div>
          <div className="ax-testi-card-name">{testimonial.customer_name}</div>
          <div className="ax-testi-card-role">{testimonial.company_name}</div>
        </div>
      </div>

      {/* BODY */}
      <div className="ax-testi-card-body mt-3">
        <p className="ax-testi-card-text   ">{testimonial.message}</p>
      </div>

    </div>
  );
}

export default function Testimonial({ testimonials }  ) {
  const styleRef = useRef(null);
  //  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    if (!document.getElementById("ax-testi-styles")) {
      const tag = document.createElement("style");
      tag.id = "ax-testi-styles";
      tag.innerHTML = styles;
      document.head.appendChild(tag);
    }
    return () => {
      const tag = document.getElementById("ax-testi-styles");
      if (tag) tag.remove();
    };
  }, []);




//   useEffect(() => {
// fetchHomePageDetails();
//   },[])

//   const fetchHomePageDetails = async () =>{
//     const res = await homePageAPI.homePage(homePagePayload);
//      if (res.code === 200) {
//       const result = res.data;
//       const allBanners = result?.banners || [];     
//       setTestimonials(result?.testimonials );
//     }
//   }

  return (
    <>
      {testimonials && testimonials.length > 0 && (
    <section className="ax-testi-section">
      <div className="container-fluid px-4 px-md-5">
        <div className="row align-items-center g-0">

          {/* LEFT */}
          <div className="col-12 col-lg-5 ax-testi-left-col pe-lg-4">
            <div className="ax-testi-badge">
              <span className="ax-testi-badge-dot" />
              Client Testimonials
            </div>

            <h2 className="ax-testi-heading">
              Hear From the<br />
              <span className="ax-testi-heading-red">Clients</span> We<br />
              Have <span className="ax-testi-heading-cursive">Worked</span> With
            </h2>

            <p className="ax-testi-subtext">
              Real results. Real experiences.<br />
              See how we've helped brands<br />
              grow faster.
            </p>
          </div>

          {/* RIGHT */}
          <div className="col-12 col-lg-7">
            <div className="ax-testi-track-outer">
              <div className="ax-testi-track">
                {testimonials.map((item, index) => (
                  <TestimonialCard key={index} testimonial={item} />
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
      )}
    </>
  );
}